/**
 * Volume bundle quick-add + optional single-item discount button.
 * Merges cart lines that share variant + matching _bundle_discount property.
 */
(function () {
  'use strict';

  function parseJsonAttr(el, attr) {
    var raw = el.getAttribute(attr);
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      console.warn('[volume-bundle]', 'bad JSON', attr, e);
      return {};
    }
  }

  /** Symbol + localized amount digits only (no "USD" code, no Intl currency style). */
  function formatTierPrice(cents) {
    var c = Number(cents);
    if (!Number.isFinite(c)) return '';
    var sym =
      typeof window !== 'undefined' && window.BlueBirdCurrencySymbol != null ? String(window.BlueBirdCurrencySymbol) : '$';

    var amountStr = '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        amountStr = Shopify.formatMoney(c, '{{amount_with_comma_separator}}');
      } catch (e) {
        try {
          amountStr = Shopify.formatMoney(c, '{{amount}}');
        } catch (e2) {
          console.warn('[volume-bundle]', 'formatMoney amount', e, e2);
        }
      }
    }
    if (amountStr !== '') return sym.trim() + amountStr;

    var n = c / 100;
    var sign = n < 0 ? '-' : '';
    return sign + String(sym || '$').trim() + Math.abs(n).toFixed(2);
  }

  function formatMoney(cents, formatSourceEl, explicitFormat) {
    void formatSourceEl;
    void explicitFormat;
    return formatTierPrice(cents);
  }

  function bundlePrice(unitCents, qty, discountRate) {
    var total = unitCents * qty;
    var dr = Number(discountRate);
    if (!Number.isFinite(dr) || dr <= 0) return total;
    var discount = Math.floor(total * dr);
    return total - discount;
  }

  function discountRateFromPct(wrapper, attr) {
    var raw = wrapper.getAttribute(attr);
    var n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n < 0) return 0;
    return n / 100;
  }

  function syncStackTierOnePrice(stack) {
    if (!(stack instanceof HTMLElement)) return;
    var prices = parseJsonAttr(stack, 'data-variant-prices');
    var vid = String(stack.dataset.variantId || '');
    var unit = Number(prices[vid]);
    if (!Number.isFinite(unit)) return;
    var pctRaw = stack.getAttribute('data-bundle-single-pct');
    var n = pctRaw != null ? parseInt(pctRaw, 10) : 0;
    if (!Number.isFinite(n) || n < 0) n = 0;
    var r = n / 100;
    var p1 = stack.querySelector('.bundle-price-1');
    if (p1) {
      p1.textContent = formatMoney(bundlePrice(unit, 1, r), stack);
    }
    syncRcOnetimePurchasePrice(stack);
  }

  function getStackTierOnePriceCents(stack) {
    if (!(stack instanceof HTMLElement)) return null;
    var prices = parseJsonAttr(stack, 'data-variant-prices');
    var vid = String(stack.dataset.variantId || '');
    var unit = Number(prices[vid]);
    if (!Number.isFinite(unit)) return null;
    var pctRaw = stack.getAttribute('data-bundle-single-pct');
    var n = pctRaw != null ? parseInt(pctRaw, 10) : 0;
    if (!Number.isFinite(n) || n < 0) n = 0;
    return bundlePrice(unit, 1, n / 100);
  }

  function syncBundlePrices(wrapper) {
    var prices = parseJsonAttr(wrapper, 'data-variant-prices');
    var avail = parseJsonAttr(wrapper, 'data-variant-available');
    var vid = String(wrapper.dataset.variantId || '');
    var unit = Number(prices[vid]);
    if (!Number.isFinite(unit)) return;

    var r2 = discountRateFromPct(wrapper, 'data-bundle-discount-pct-2');
    var r3 = discountRateFromPct(wrapper, 'data-bundle-discount-pct-3');

    var p2 = wrapper.querySelector('.bundle-price-2');
    var p3 = wrapper.querySelector('.bundle-price-3');
    if (p2) p2.textContent = formatMoney(bundlePrice(unit, 2, r2), wrapper);
    if (p3) p3.textContent = formatMoney(bundlePrice(unit, 3, r3), wrapper);

    var ok = avail[vid] === true;
    wrapper.querySelectorAll('.btn-add-bundle').forEach(function (btn) {
      btn.disabled = !ok;
    });

    var hostStack = wrapper.closest('.bundle-pdp-offer-stack, .bundle-card-offer-stack');
    if (hostStack) syncStackTierOnePrice(hostStack);
  }

  /** Form that owns PDP bundle actions (needed when bundle stack is moved out of <form>). */
  function resolveBundleHostForm(el) {
    if (!(el instanceof HTMLElement)) return null;
    var withId =
      el.closest('[data-bundle-product-form-id]') || (el.closest && el.closest('.bundle-pdp-offer-stack'));
    var fid = withId ? withId.getAttribute('data-bundle-product-form-id') : null;
    if (fid) {
      var f = document.getElementById(fid);
      if (f instanceof HTMLFormElement) return f;
    }
    return el.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  }

  /** Resolve first match in root, then descend into open shadow roots (ReCharge widgets). */
  function querySelectorDeep(root, selector) {
    if (!root || !root.querySelector) return null;
    var hit = null;
    try {
      hit = root.querySelector(selector);
    } catch (e) {
      return null;
    }
    if (hit) return hit;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        hit = querySelectorDeep(nodes[i].shadowRoot, selector);
        if (hit) return hit;
      }
    }
    return null;
  }

  /** Walk light DOM plus open shadow roots. */
  function walkShadowInclusive(root, visit) {
    if (!root) return;
    visit(root);
    if (!root.querySelectorAll) return;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) walkShadowInclusive(nodes[i].shadowRoot, visit);
    }
  }

  /** All Recharge Subscription Widget `.rc-purchase-option` roots under scope (shadow-safe). */
  function gatherRcPurchaseOptions(scope, acc) {
    walkShadowInclusive(scope, function (subroot) {
      if (!(subroot && subroot.querySelectorAll)) return;
      try {
        var opts = subroot.querySelectorAll('.rc-purchase-option');
        var j = 0;
        for (j = 0; j < opts.length; j++) {
          acc.push(opts[j]);
        }
      } catch (e) {
        void e;
      }
    });
  }

  function rcPurchaseRowLooksSelected(po) {
    if (!po || !po.matches) return false;
    var row = po.classList.contains('rc-purchase-option')
      ? po
      : po.closest && po.closest('.rc-purchase-option');
    if (!row) return false;
    if (row.classList.contains('rc-selected')) return true;
    if (
      row.hasAttribute('rc-selected') &&
      String(row.getAttribute('rc-selected') || '').trim().toLowerCase() !== 'false'
    ) {
      return true;
    }
    if (row.getAttribute('aria-selected') === 'true') return true;
    if (row.getAttribute('aria-checked') === 'true') return true;
    var innerChecked = row.querySelector('input[type="radio"]:checked, input:checked');
    if (innerChecked) return true;
    return false;
  }

  /** The selected Subscription Widget purchase option row (v2+) or null. */
  function selectedRcPurchaseOption(scope) {
    var bucket = [];
    gatherRcPurchaseOptions(scope, bucket);
    var i = 0;
    for (i = 0; i < bucket.length; i++) {
      if (rcPurchaseRowLooksSelected(bucket[i])) return bucket[i];
    }

    var deepInner =
      querySelectorDeep(scope, '.rc-purchase-option [rc-selected]') ||
      querySelectorDeep(scope, '.rc-purchase-option input[type="radio"]:checked');
    var host =
      deepInner && deepInner.closest && deepInner.closest('.rc-purchase-option');
    if (host && rcPurchaseRowLooksSelected(host)) return host;

    return null;
  }

  /** Recharge docs: `.rc-purchase-option__onetime` / `.rc-purchase-option__subscription`. */
  function rcPurchaseContextKind(node) {
    if (!node || !node.closest) return null;
    if (
      node.closest('.rc-purchase-option__onetime') ||
      node.closest('.rc-option__onetime') ||
      node.closest('[class*="purchase-option__onetime"]')
    ) {
      return 'onetime';
    }
    if (
      node.closest('.rc-purchase-option__subscription') ||
      node.closest('.rc-option__subsave') ||
      node.closest('[class*="purchase-option__subscription"]')
    ) {
      return 'subscription';
    }
    return null;
  }

  function rcPurchaseOptionKind(po) {
    if (!po) return null;
    var ctx = rcPurchaseContextKind(po);
    if (ctx) return ctx;

    var ot =
      po.classList.contains('rc-purchase-option__onetime') ||
      po.classList.contains('rc-selection__onetime') ||
      po.classList.contains('rc-selection-onetime') ||
      po.classList.contains('rc-selection__one_time');
    var sub =
      po.classList.contains('rc-purchase-option__subscription') ||
      po.classList.contains('rc-selection__subscription') ||
      po.classList.contains('rc-selection-subscription');
    if (ot && !sub) return 'onetime';
    if (sub && !ot) return 'subscription';

    var hay = '';
    try {
      hay = (' ' + String(po.className || '').replace(/\s+/g, ' ') + ' ').toLowerCase();
    } catch (e2) {
      void e2;
    }
    if (hay.indexOf('purchase-option__onetime') !== -1 || hay.indexOf('one_time') !== -1)
      return 'onetime';
    if (hay.indexOf('purchase-option__subscription') !== -1 || hay.indexOf('selection__subscription') !== -1)
      return 'subscription';

    return null;
  }

  function findRcOnetimePurchaseSection(scope) {
    if (!scope) return null;
    var hit =
      querySelectorDeep(scope, '.rc-purchase-option__onetime') ||
      querySelectorDeep(scope, '.rc-option__onetime') ||
      querySelectorDeep(scope, '[class*="purchase-option__onetime"]');
    if (hit) return hit;

    var candidates = [];
    walkShadowInclusive(scope, function (subroot) {
      if (!(subroot && subroot.querySelectorAll)) return;
      try {
        var rows = subroot.querySelectorAll('.rc-purchase-option');
        var i = 0;
        for (i = 0; i < rows.length; i++) {
          if (candidates.indexOf(rows[i]) === -1) candidates.push(rows[i]);
        }
      } catch (e) {
        void e;
      }
    });

    var j = 0;
    for (j = 0; j < candidates.length; j++) {
      if (rcPurchaseOptionKind(candidates[j]) === 'onetime') return candidates[j];
      var label = (candidates[j].textContent || '').toLowerCase();
      if (label.indexOf('one-time') !== -1 || label.indexOf('one time') !== -1) {
        return candidates[j];
      }
    }

    return null;
  }

  function findRcOnetimePurchaseOption(scope) {
    if (!scope) return null;

    var section = findRcOnetimePurchaseSection(scope);
    if (section) {
      var row = querySelectorDeep(section, '.rc-purchase-option');
      return row || section;
    }

    var bucket = [];
    gatherRcPurchaseOptions(scope, bucket);
    var i = 0;
    for (i = 0; i < bucket.length; i++) {
      if (rcPurchaseOptionKind(bucket[i]) === 'onetime') return bucket[i];
    }

    return (
      querySelectorDeep(scope, '.rc-purchase-option.rc-purchase-option__onetime') ||
      querySelectorDeep(scope, '.rc-purchase-option__onetime')
    );
  }

  function getStackUnitPriceCents(stack) {
    if (!(stack instanceof HTMLElement)) return null;
    var prices = parseJsonAttr(stack, 'data-variant-prices');
    var vid = String(stack.dataset.variantId || '');
    var unit = Number(prices[vid]);
    return Number.isFinite(unit) ? unit : null;
  }

  function setTextIfChanged(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function hideNativeRcOnetimePrices(root, keepWrap) {
    if (!root) return;
    var selectors = [
      '.rc-purchase-option__price',
      '.rc-price',
      '[part="rc-purchase-option__price"]',
      '[part*="purchase-option__price"]',
      '.rc-purchase-option__original-price',
      '.rc-purchase-option__discounted-price',
      '.rc-option__price'
    ];
    var i = 0;
    var j = 0;
    var nodes;

    walkShadowInclusive(root, function (subroot) {
      if (!(subroot && subroot.querySelectorAll)) return;
      try {
        var priceWraps = subroot.querySelectorAll('.rc-purchase-option__prices');
        for (j = 0; j < priceWraps.length; j++) {
          var pw = priceWraps[j];
          pw.style.removeProperty('display');
          pw.style.removeProperty('visibility');
          pw.style.removeProperty('height');
          pw.style.removeProperty('overflow');
          pw.removeAttribute('aria-hidden');
          pw.removeAttribute('data-bundle-rc-native-price-hidden');
        }
      } catch (e0) {
        void e0;
      }
    });

    walkShadowInclusive(root, function (subroot) {
      if (!(subroot && subroot.querySelectorAll)) return;
      for (i = 0; i < selectors.length; i++) {
        try {
          nodes = subroot.querySelectorAll(selectors[i]);
          for (j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (keepWrap && (node === keepWrap || keepWrap.contains(node) || node.contains(keepWrap))) {
              continue;
            }
            if (node.closest && node.closest('.bundle-rc-onetime-price-display')) continue;
            node.setAttribute('data-bundle-rc-native-price-hidden', 'true');
            node.style.setProperty('display', 'none');
            node.style.setProperty('visibility', 'hidden');
            node.style.setProperty('height', '0');
            node.style.setProperty('overflow', 'hidden');
            node.setAttribute('aria-hidden', 'true');
          }
        } catch (e) {
          void e;
        }
      }
    });
  }

  function ensureRcOnetimePriceDisplay(scope, compareFormatted, saleFormatted, hasDiscount) {
    var section = findRcOnetimePurchaseSection(scope);
    if (!section) return;

    var row = findRcOnetimePurchaseOption(scope) || section;
    var legacyOverlay = section.querySelector('.bundle-rc-onetime-price-overlay');
    if (legacyOverlay) legacyOverlay.remove();

    var pricesHost =
      querySelectorDeep(row, '.rc-purchase-option__prices') ||
      querySelectorDeep(section, '.rc-purchase-option__prices');
    if (!pricesHost) return;

    var wrap = pricesHost.querySelector('.bundle-rc-onetime-price-display');
    if (!wrap) {
      wrap = row.querySelector(':scope > .bundle-rc-onetime-price-display');
    }
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'bundle-rc-onetime-price-display';
      wrap.innerHTML =
        '<s class="bundle-rc-onetime-price-display__compare"></s>' +
        '<span class="bundle-rc-onetime-price-display__sale"></span>';
    }

    if (wrap.parentNode !== pricesHost) {
      pricesHost.appendChild(wrap);
    }

    row.querySelectorAll('.bundle-rc-onetime-price-display').forEach(function (el) {
      if (el !== wrap) el.remove();
    });

    var compareEl = wrap.querySelector('.bundle-rc-onetime-price-display__compare');
    var saleEl = wrap.querySelector('.bundle-rc-onetime-price-display__sale');
    if (compareEl) {
      compareEl.hidden = !hasDiscount;
      if (hasDiscount) setTextIfChanged(compareEl, compareFormatted);
    }
    if (saleEl) setTextIfChanged(saleEl, saleFormatted);

    wrap.style.removeProperty('display');
    wrap.style.removeProperty('visibility');
    wrap.style.removeProperty('height');
    wrap.style.removeProperty('overflow');
    wrap.removeAttribute('aria-hidden');

    hideNativeRcOnetimePrices(row, wrap);

    row.classList.add('bundle-rc-onetime-price-overlay-host');
    section.classList.add('bundle-rc-onetime-price-overlay-host');
  }

  /** Match Recharge “One-time purchase” row price to Add 1 / tier-1 bundle price. */
  function syncRcOnetimePurchasePrice(stack) {
    if (!(stack instanceof HTMLElement)) return false;
    if (!stack.classList.contains('bundle-pdp-offer-stack')) return false;

    var unitCents = getStackUnitPriceCents(stack);
    var saleCents = getStackTierOnePriceCents(stack);
    if (unitCents === null || saleCents === null) return false;

    var scope = stack.closest('.product__info-container') || stack.closest('.product__info-wrapper');
    if (!scope) return false;

    var compareFormatted = formatMoney(unitCents, stack);
    var saleFormatted = formatMoney(saleCents, stack);
    var hasDiscount = saleCents < unitCents;

    stack.setAttribute('data-bundle-rc-onetime-display', saleFormatted);
    stack.setAttribute('data-bundle-rc-onetime-compare', hasDiscount ? compareFormatted : '');

    ensureRcOnetimePriceDisplay(scope, compareFormatted, saleFormatted, hasDiscount);
    return true;
  }

  function syncAllRcOnetimePurchasePrices() {
    document.querySelectorAll('.bundle-pdp-offer-stack').forEach(syncRcOnetimePurchasePrice);
  }

  var rcOnetimePriceSyncTimer;
  function scheduleRcOnetimePriceSync() {
    clearTimeout(rcOnetimePriceSyncTimer);
    rcOnetimePriceSyncTimer = setTimeout(syncAllRcOnetimePurchasePrices, 80);
  }

  var rcOnetimePriceObserver;
  function initSyncRcOnetimePurchasePrice() {
    var stack = document.querySelector(
      '.product__info-container .bundle-pdp-offer-stack, .product__info-wrapper .bundle-pdp-offer-stack'
    );
    if (!stack) return;

    scheduleRcOnetimePriceSync();
    var scope =
      stack.closest('.product__info-container') || stack.closest('.product__info-wrapper');
    [120, 400, 900, 2000, 4500, 8000, 12000, 20000].forEach(function (ms) {
      setTimeout(scheduleRcOnetimePriceSync, ms);
    });

    if (!scope || rcOnetimePriceObserver) return;
    rcOnetimePriceObserver = new MutationObserver(scheduleRcOnetimePriceSync);
    rcOnetimePriceObserver.observe(scope, { childList: true, subtree: true, characterData: true });
  }

  /** True when subscription is selected → hide volume bundle (one-time-only offers). */
  function subscriptionBlocksOffers(stackOrBundle) {
    if (stackOrBundle.dataset.bundleHideSubscription !== 'true') return false;

    var scope =
      stackOrBundle.closest('.product__info-container') ||
      stackOrBundle.closest('.product__info-wrapper');
    if (!scope) {
      scope = document.body;
    }
    var form = resolveBundleHostForm(stackOrBundle);

    // 1) Recharge Subscription Widget v2+: selected purchase-option row (incl. shadow roots)
    var poSel = selectedRcPurchaseOption(scope);
    if (poSel) {
      var kind = rcPurchaseOptionKind(poSel);
      if (kind === 'subscription') return true;
      if (kind === 'onetime') return false;
      // Recognized RC row selected but classifier unknown — defer to radios / form rather than flashing wrong state
    }

    // 2) Legacy radios (Liquid / legacy RC)
    var subRadio = querySelectorDeep(
      scope,
      '.rc-option__subsave input[type="radio"]:checked, .rc-option__subsave input:checked'
    );
    var oneRadio = querySelectorDeep(
      scope,
      '.rc-option__onetime input[type="radio"]:checked, .rc-option__onetime input:checked'
    );
    if (subRadio && !oneRadio) return true;
    if (oneRadio && !subRadio) return false;

    // 3) Form selling_plan
    if (form) {
      var field = form.querySelector('[name="selling_plan"]');
      if (field) {
        if (field.tagName === 'SELECT') {
          return Boolean(field.value && String(field.value).trim() !== '');
        }
        var checked = form.querySelector('input[name="selling_plan"]:checked');
        return Boolean(checked && checked.value && String(checked.value).trim() !== '');
      }
    }

    return false;
  }

  /** Subscription widget / selling_plan fields exist on this PDP (shadow-safe DOM probe). */
  function productHasSellingPlans(stackOrBundle) {
    var scope =
      stackOrBundle.closest('.product__info-container') ||
      stackOrBundle.closest('.product__info-wrapper');
    var form = resolveBundleHostForm(stackOrBundle);

    if (scope && querySelectorDeep(scope, '[name="selling_plan"]')) return true;
    if (form && querySelectorDeep(form, '[name="selling_plan"]')) return true;
    if (form && form.querySelector('[name="selling_plan"]')) return true;

    if (!scope) return false;

    var bucket = [];
    gatherRcPurchaseOptions(scope, bucket);
    if (bucket.length > 0) return true;

    return Boolean(
      querySelectorDeep(scope, '.rc-purchase-option') ||
        querySelectorDeep(scope, '.rc-option__onetime') ||
        querySelectorDeep(scope, '.rc-option__subsave')
    );
  }

  /** Shopify Liquid marks subscription-capable products; avoids missing RC nodes before hydration. */
  function productSellingPlansExpectedFromTheme(stack) {
    return stack.dataset.bundleProductHasSellingPlans === 'true';
  }

  /** Hide default qty + ATC row while one-time + volume bundles show; reveal when subscribe is selected. */
  function updateMainAtcRowForBundleSubscription(stack) {
    if (!(stack instanceof HTMLElement)) return;
    if (stack.dataset.bundleHideMainAtcOnOnetime !== 'true') return;

    var form = resolveBundleHostForm(stack);
    if (!form) return;
    var atcRow =
      form.querySelector('.product-form__buttons.cstm_qnty_add_btn') ||
      form.querySelector('.product-form__buttons');
    if (!atcRow) return;

    var hasSubs =
      productSellingPlansExpectedFromTheme(stack) || productHasSellingPlans(stack);
    if (!hasSubs) {
      atcRow.classList.remove('bundle-main-atc--volume-onetime-hidden');
      return;
    }

    var subscriptionChosen = subscriptionBlocksOffers(stack);
    atcRow.classList.toggle('bundle-main-atc--volume-onetime-hidden', !subscriptionChosen);
  }

  function updateOfferSubscriptionVisibility(el) {
    if (el.dataset.bundleHideSubscription !== 'true') return;
    var hide = subscriptionBlocksOffers(el);
    el.classList.toggle('bundle-pdp-offer-stack--hide-for-subscription', hide);
    el.setAttribute('aria-hidden', hide ? 'true' : 'false');
  }

  function refreshSubscriptionStates() {
    document.querySelectorAll('[data-bundle-hide-subscription="true"]').forEach(function (el) {
      updateOfferSubscriptionVisibility(el);
      updateMainAtcRowForBundleSubscription(el);
    });
    scheduleRcOnetimePriceSync();
  }

  var subWatchTimer;
  function scheduleSubscriptionRefresh() {
    clearTimeout(subWatchTimer);
    subWatchTimer = setTimeout(refreshSubscriptionStates, 60);
  }

  function watchSellingPlans() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name !== 'selling_plan') return;
      refreshSubscriptionStates();
    });

    document.querySelectorAll('[data-bundle-hide-subscription="true"]').forEach(function (stack) {
      var form = resolveBundleHostForm(stack);
      if (form) {
        var mo = new MutationObserver(scheduleSubscriptionRefresh);
        mo.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['value', 'checked', 'selected']
        });
      }
      var productScope = stack.closest('.product__info-container') || stack.closest('.product__info-wrapper');
      if (productScope) {
        var moPd = new MutationObserver(scheduleSubscriptionRefresh);
        moPd.observe(productScope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'rc-selected',
            'checked',
            'value',
            'class',
            'aria-checked',
            'aria-selected',
            'data-state'
          ]
        });
      }
    });

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        var rcHit = t.closest(
          '.rc-purchase-option, .rc-option__onetime, .rc-option__subsave, .rc-radio'
        );
        if (!rcHit) return;
        if (!rcHit.closest('.product__info-container') && !rcHit.closest('.product__info-wrapper')) return;
        scheduleSubscriptionRefresh();
      },
      true
    );

    refreshSubscriptionStates();
  }

  document.addEventListener('shopall3:products-loaded', function () {
    document.querySelectorAll('.bundle-cart-buttons').forEach(syncBundlePrices);
    document.querySelectorAll('.bundle-pdp-offer-stack, .bundle-card-offer-stack').forEach(syncStackTierOnePrice);
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!(target instanceof HTMLElement)) return;

    if (target.matches('input[name="id"]')) {
      var form = target.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      if (!form) return;
      var vidStr = String(target.value);
      var productScope = target.closest('.product__info-container') || target.closest('.product__info-wrapper');
      var bundle = form.querySelector('.bundle-cart-buttons');
      var stack =
        (productScope && productScope.querySelector('.bundle-pdp-offer-stack')) ||
        form.querySelector('.bundle-pdp-offer-stack');
      var meta = bundle || stack;
      if (bundle) {
        bundle.dataset.variantId = vidStr;
        syncBundlePrices(bundle);
      }
      if (stack) {
        stack.dataset.variantId = vidStr;
        updateOfferSubscriptionVisibility(stack);
        updateMainAtcRowForBundleSubscription(stack);
        syncStackTierOnePrice(stack);
      }
      var availMap = meta ? parseJsonAttr(meta, 'data-variant-available') : {};
      var okSingle = availMap[vidStr] === true;
      var singleBtnsScope = stack || form;
      singleBtnsScope.querySelectorAll('.btn-bundle-single-add').forEach(function (b) {
        b.disabled = !okSingle;
      });
      return;
    }

    if (target.matches('select.v_cstm_data.rrr')) {
      var card = target.closest('.shop-all-3-card') || target.closest('.card-wrapper');
      if (!card) return;
      var bundle = card.querySelector('.bundle-cart-buttons');
      var stackMeta = card.querySelector('.bundle-card-offer-stack');
      var meta = bundle || stackMeta;
      if (!meta) return;
      var opt = target.options[target.selectedIndex];
      var vl = opt && opt.getAttribute('data-vl');
      if (!vl) return;
      if (bundle) {
        bundle.dataset.variantId = String(vl);
        syncBundlePrices(bundle);
      }
      if (stackMeta) {
        stackMeta.dataset.variantId = String(vl);
        syncStackTierOnePrice(stackMeta);
      }
      var av = parseJsonAttr(meta, 'data-variant-available');
      card.querySelectorAll('.btn-bundle-single-add').forEach(function (b) {
        b.disabled = av[String(vl)] !== true;
      });
    }
  });

  function cartAddOrMerge(variantId, qty, label) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var propLabel = (label || '').trim();
        var match =
          propLabel &&
          cart.items.find(function (item) {
            return (
              Number(item.variant_id) === variantId &&
              item.properties &&
              item.properties._bundle_discount === propLabel
            );
          });
        if (match) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: match.key, quantity: match.quantity + qty })
          });
        }
        var item = { id: variantId, quantity: qty };
        if (propLabel) {
          item.properties = { _bundle_discount: propLabel };
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (res) {
        if (!res || !res.ok) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              throw new Error((data && data.description) || 'Cart error');
            });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        if (typeof window.update_cart_new === 'function') {
          window.update_cart_new();
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btnSingle = e.target.closest('.btn-bundle-single-add');
    if (btnSingle && !btnSingle.disabled) {
      var form = resolveBundleHostForm(btnSingle);
      if (!form) return;
      var stackHide = btnSingle.closest('[data-bundle-hide-subscription="true"]');
      if (stackHide && subscriptionBlocksOffers(stackHide)) return;

      e.preventDefault();
      e.stopPropagation();

      var stackInline = btnSingle.closest('.bundle-card-offer-stack');
      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? Number(idInput.value) : NaN;
      if (!Number.isFinite(variantId) && stackInline && stackInline.dataset.variantId) {
        variantId = Number(stackInline.dataset.variantId);
      }
      if (!Number.isFinite(variantId)) {
        var selMulti = form.querySelector('select.v_cstm_data.rrr');
        if (selMulti && selMulti.options[selMulti.selectedIndex]) {
          var vl = selMulti.options[selMulti.selectedIndex].getAttribute('data-vl');
          variantId = vl ? Number(vl) : NaN;
        }
      }
      if (!Number.isFinite(variantId)) {
        var selOne = form.querySelector('select.data-span option');
        if (selOne) {
          var vlOne = selOne.getAttribute('data-vl');
          variantId = vlOne ? Number(vlOne) : NaN;
        }
      }
      var label = btnSingle.getAttribute('data-bundle-discount-label') || '';

      if (!Number.isFinite(variantId)) {
        console.warn('[volume-bundle]', 'no variant for single add');
        return;
      }

      btnSingle.classList.add('is-loading');
      btnSingle.setAttribute('aria-busy', 'true');
      cartAddOrMerge(variantId, 1, label)
        .catch(function (err) {
          console.error('[volume-bundle]', err);
        })
        .finally(function () {
          btnSingle.classList.remove('is-loading');
          btnSingle.removeAttribute('aria-busy');
        });
      return;
    }

    var btn = e.target.closest('.btn-add-bundle');
    if (!btn || btn.disabled) return;
    var wrapper = btn.closest('.bundle-cart-buttons');
    if (!wrapper) return;

    if (subscriptionBlocksOffers(wrapper.closest('[data-bundle-hide-subscription="true"]') || wrapper)) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    var variantId = Number(wrapper.dataset.variantId);
    var qty = Number(btn.dataset.qty);
    var label = (btn.getAttribute('data-bundle-discount-label') || '').trim();

    if (!Number.isFinite(variantId) || !Number.isFinite(qty) || qty < 1) {
      console.warn('[volume-bundle]', 'missing variant or qty');
      return;
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    cartAddOrMerge(variantId, qty, label)
      .catch(function (err) {
        console.error('[volume-bundle]', err);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

  /** PDP: Sezzle app block is usually ordered before buy_buttons; move it below volume tier buttons. */
  function findSezzleShopifyAppBlock(scope) {
    if (!scope || !scope.querySelectorAll) return null;
    var byIframe = scope.querySelector(
      'iframe[src*="sezzle.com"], iframe[src*="widget.sezzle"], iframe[src*="sezzle"]'
    );
    if (byIframe) {
      var b = byIframe.closest('.shopify-app-block');
      if (b) return b;
    }
    var blocks = scope.querySelectorAll('.shopify-app-block');
    var i = 0;
    for (i = 0; i < blocks.length; i++) {
      var bl = blocks[i];
      if (querySelectorDeep(bl, 'iframe[src*="sezzle"]')) return bl;
      try {
        if (bl.querySelector('[class*="sezzle"], [class*="Sezzle"]')) return bl;
      } catch (err) {
        void err;
      }
    }
    return null;
  }

  var sezzleMoveObserver;
  function moveSezzleBelowPdpBundleStack() {
    var stack = document.querySelector(
      '.product__info-container .bundle-pdp-offer-stack, .product__info-wrapper .bundle-pdp-offer-stack'
    );
    if (!stack || !stack.parentNode) return false;

    var form = stack.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    if (!form || !form.contains(stack)) return false;

    var scope = stack.closest('.product__info-container') || stack.closest('.product__info-wrapper');
    var block = scope ? findSezzleShopifyAppBlock(scope) : null;
    if (!block) return false;
    if (stack.contains(block)) return false;

    if (block.previousElementSibling === stack) {
      block.setAttribute('data-bundle-sezzle-after-stack', '');
      return true;
    }

    stack.parentNode.insertBefore(block, stack.nextSibling);
    block.setAttribute('data-bundle-sezzle-after-stack', '');
    return true;
  }

  function initMoveSezzleBelowPdpBundleStack() {
    var stack = document.querySelector(
      '.product__info-container .bundle-pdp-offer-stack, .product__info-wrapper .bundle-pdp-offer-stack'
    );
    if (!stack) return;

    function disconnectObserver() {
      if (sezzleMoveObserver) {
        sezzleMoveObserver.disconnect();
        sezzleMoveObserver = null;
      }
    }

    function tick() {
      if (!moveSezzleBelowPdpBundleStack()) return;
      disconnectObserver();
    }

    if (moveSezzleBelowPdpBundleStack()) return;

    var scope =
      stack.closest('.product__info-container') || stack.closest('.product__info-wrapper');
    [120, 400, 900, 2000, 4500].forEach(function (ms) {
      setTimeout(tick, ms);
    });

    if (!scope) return;
    sezzleMoveObserver = new MutationObserver(tick);
    sezzleMoveObserver.observe(scope, { childList: true, subtree: true });
    setTimeout(function () {
      disconnectObserver();
    }, 16000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    watchSellingPlans();
    initMoveSezzleBelowPdpBundleStack();
    initSyncRcOnetimePurchasePrice();
    /* ReCharge hydrates after first paint — re-sync visibility as selling_plan / rc-selected settles */
    [0, 80, 200, 450, 1000, 2200].forEach(function (ms) {
      setTimeout(refreshSubscriptionStates, ms);
    });
    document.querySelectorAll('.bundle-cart-buttons').forEach(syncBundlePrices);
    document.querySelectorAll('.bundle-pdp-offer-stack, .bundle-card-offer-stack').forEach(syncStackTierOnePrice);
    document.querySelectorAll('.bundle-card-offer-stack').forEach(function (stack) {
      var card = stack.closest('.shop-all-3-card') || stack.closest('.card-wrapper');
      var bundle = card && card.querySelector('.bundle-cart-buttons');
      var meta = bundle || stack;
      if (!card || !meta) return;
      var vid = meta.dataset.variantId;
      var avail = parseJsonAttr(meta, 'data-variant-available');
      card.querySelectorAll('.btn-bundle-single-add').forEach(function (btn) {
        btn.disabled = avail[String(vid)] !== true;
      });
    });
  });
})();
